export type SocialPlatform = "instagram" | "facebook" | "whatsapp";
export type SocialLink = { platform: SocialPlatform; label: string; href: string };

export const siteConfig = {
  name: "Purple Octopus",
  legalName: "Purple Octopus Ventures",
  tagline: "One-stop Shop for Diving & Water Sports in India",
  description:
    "Purple Octopus is the one-stop shop for diving and water sports in India, from equipment supply and certification to adventure safaris.",
  url: "https://www.thepurpleoctopus.in",
  logos: {
    primary: {
      src: "/images/main-logos.png",
      alt: "Purple Octopus Logo",
      width: 300,
      height: 70,
    },
    secondary: {
      src: "/images/make-in-indias.png",
      alt: "Make in India Logo",
      width: 103,
      height: 48,
    },
  },
  cta: {
    label: "Get in Touch",
    href: "/contact",
  },
  contact: {
    email: "info@purpleoctopus.in",
  },

  footer: {
    description:
      "Going beyond & deeper for the requirements of those we serve.",
    logo: { src: "/images/main-logos.png", alt: "Purple Octopus Ventures", width: 400, height: 100 },
    communityTitle: "Our Community",
    social: [
      { platform: "instagram", label: "Instagram", href: "https://www.instagram.com/purpleoctopus.in/" },
      { platform: "facebook", label: "Facebook", href: "https://www.facebook.com/ThePurpleOctopus/" },
      { platform: "whatsapp", label: "WhatsApp", href: "https://wa.me/919920763671" },
    ] satisfies SocialLink[],
  },
};
